import React from 'react'

import Header from '../../../components/header'
import FormFactory from '../../../components/form/form-factory'
import BackButton from '../../../components/back-button'

import { Container, FormContainer } from './styles'

import IFormPage from '../../../interfaces/form-page'
import IPlan from '../../../interfaces/plan'
import PlanCard from '../../../components/plan-card'

type IProps = IFormPage & {
  plan: IPlan
}

const Checkout = ({
  dataForm, onSubmit, errorMessage, plan,
}: IProps) => (
  <Container>
    <Header title="Pagamento" />
    <FormContainer>
      {plan && <PlanCard {...plan} selectedPlan={plan.id} isUserPlan={false} />}
      <FormFactory
        data={dataForm}
        onSubmit={onSubmit}
        submitErrorMessage={errorMessage}
      />
      <BackButton />
    </FormContainer>
  </Container>
)

export default Checkout
